import { TranscriptionConstants } from "lookup/TranscriptionConstants";

export const convertToComponentStructureResponse = (incomingResponse) => {
  let formattedResponse = {};
  for (let section of incomingResponse[
    TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.sections
  ]) {
    formattedResponse[
      section[TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.sectionName]
    ] = {};
    formattedResponse[section[TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.sectionName]][
      TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.selected
    ] =
      section[TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.selected] ===
      null
        ? false
        : section[TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.selected];

    for (let field of section[
      TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.fields
    ]) {
      if (field != null) {
        formattedResponse[
          section[
            TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.sectionName
          ]
        ][field[TranscriptionConstants.TRANSCRIBER_OBJECT_KEYS.fieldName]] =
          field;
      }
    }
  }
  return formattedResponse;
};
